/** Basic cookie helpers for lightweight frontend preferences. */

function escapeRegExp(value: string): string {
	return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function getCookie(name: string): string | null {
	if (typeof document === "undefined") return null;
	const match = document.cookie.match(
		new RegExp(`(?:^|; )${escapeRegExp(name)}=([^;]*)`),
	);
	return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name: string, value: string, days = 365): void {
	if (typeof document === "undefined") return;
	const maxAge = Math.max(1, Math.floor(days * 24 * 60 * 60));
	document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
	if (typeof window !== "undefined") {
		window.dispatchEvent(new CustomEvent("opus:cookie-change", { detail: { name, value } }));
	}
}
